import numeral from 'numeral';

export const yuan = (val: number | string) => `¥ ${numeral(val).format('0,0')}`;

const TOKEN_KEY = 'token';
const TOKEN_TYPE_KEY = 'tokenType';

const isBrowser = () => typeof document !== 'undefined';

const getCookie = (name: string): string => {
  if (!isBrowser()) {
    return '';
  }
  const encodedName = encodeURIComponent(name);
  const cookieItems = document.cookie ? document.cookie.split('; ') : [];
  for (const item of cookieItems) {
    const [rawKey, ...restValue] = item.split('=');
    if (rawKey === encodedName) {
      return decodeURIComponent(restValue.join('='));
    }
  }
  return '';
};

const setCookie = (name: string, value: string) => {
  if (!isBrowser()) {
    return;
  }
  const encodedName = encodeURIComponent(name);
  const encodedValue = encodeURIComponent(value);
  const attributes = ['path=/', 'SameSite=Lax'];
  document.cookie = `${encodedName}=${encodedValue}; ${attributes.join('; ')}`;
};

const removeCookie = (name: string) => {
  if (!isBrowser()) {
    return;
  }
  const encodedName = encodeURIComponent(name);
  document.cookie = `${encodedName}=; path=/; max-age=0; SameSite=Lax`;
};

export const addToken = (
  token: string, 
  tokenType: string = 'Bearer', 
  remember: boolean = false
) => {
  if (!token) return;
  if (remember) {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(TOKEN_TYPE_KEY, tokenType);
    removeCookie(TOKEN_KEY);
    removeCookie(TOKEN_TYPE_KEY);
    return;
  }

  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_TYPE_KEY);
  setCookie(TOKEN_KEY, token);
  setCookie(TOKEN_TYPE_KEY, tokenType);
};

export const getToken = () => {
  const localToken = localStorage.getItem(TOKEN_KEY);
  const localTokenType = localStorage.getItem(TOKEN_TYPE_KEY) || 'Bearer';
  if (localToken) {
    return `${localTokenType} ${localToken}`;
  }

  const cookieToken = getCookie(TOKEN_KEY);
  const cookieTokenType = getCookie(TOKEN_TYPE_KEY) || 'Bearer';
  if (cookieToken) {
    return `${cookieTokenType} ${cookieToken}`;
  }

  return '';
};

export const removeToken = () => {
  removeCookie(TOKEN_KEY);
  removeCookie(TOKEN_TYPE_KEY);
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(TOKEN_TYPE_KEY);
};